import React, { useEffect } from 'react'
import { ProSidebar, Menu, MenuItem, SidebarContent, SidebarHeader } from "react-pro-sidebar";
import LinkTwoToneIcon from '@mui/icons-material/LinkTwoTone';
import { GoIssueClosed } from 'react-icons/go';


const JobSidebar = ({ setActive, data, active, dropout }: any) => {
	// const { data } = useAppSelector((state: any) => state.job);



	const jobsidebarList = [
		{
			title: "Active",
			icon: <LinkTwoToneIcon />,
			metric: active,
			path: 1,
		},
		{
			title: "Closed",
			icon: <GoIssueClosed size={20} />,
			metric: dropout,
			path: 2,
		},
	];

	const [actives, setActives] = React.useState(1)

	useEffect(() => {
		setActive(actives)
	}, [actives, setActive])




	return (
		<div id='Sidenavbar'>
			<div id='SideBar__container'>
				<div className='SideBar__content'>
					<ProSidebar >
						<SidebarHeader>
							<h4>Jobs</h4>
						</SidebarHeader>
						<SidebarContent>
							<Menu>
								{jobsidebarList.map((item, i) => (
									<MenuItem
										key={i}
										className='Side__Content'
										active={item.path === actives}
										icon={item.icon}
										suffix={item?.metric?.length}
										onClick={() => setActives(item.path)}>
										{item.title}
									</MenuItem>
								))}
							</Menu>
						</SidebarContent>
					</ProSidebar>
				</div>
			</div>
		</div >
	)
}
export default JobSidebar

